import { useQuery } from "@tanstack/react-query";
import { PaginationState, SortingState } from "@tanstack/react-table";
import { queryInterestsPerProperty } from "../../api";
import { QueryInterestsSearchFilters } from "../../types";

interface InterestsTableQueryParams {
  pagination: PaginationState;
  sorting: SortingState;
  filters: QueryInterestsSearchFilters & {
    propertyUid: string;
  };
}

export const useQueryInterestsPerProperty = ({
  filters: { propertyUid, ...rest },
  pagination,
  sorting,
}: InterestsTableQueryParams) => {
  const query = useQuery({
    queryKey: ["interests", { propertyUid }],
    queryFn: () => {
      return queryInterestsPerProperty({
        propertyUids: [propertyUid],
        filters: { ...rest },
        pagination: {
          page: pagination.pageIndex + 1,
          pageSize: pagination.pageSize,
          orderBy: sorting?.[0]?.id ?? "id",
          orderDirection: sorting?.[0]?.desc ? "DESC" : "ASC",
        },
      });
    },
    enabled: !!propertyUid,
    select: ({ data }) => {
      return {
        ...data,
        results: data.results,
      };
    },
  });

  return query;
};
